
import React, { Component } from 'react';
import 'antd/dist/antd.css';
import '../css/lista_titular_comites.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserEdit, faUserTimes, faUserTie } from '@fortawesome/free-solid-svg-icons';
import '../css/lista_representantes.css';
import { Row, Col, Spin } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Table, Divider } from 'antd';
import { Modal, Button, message, Drawer, Form, Input, Select, DatePicker, Tooltip, Icon, Cascader, AutoComplete, Checkbox, } from 'antd';

import { logout, titular_comite_representantes, eliminar_representante, actualizarTitular, whoAmI, titular_comite_representante, actualizar_campos_representante } from '../utils/JWTAuth';

import NavBar from './NavBar';

const h3Test = styled.h3`
  text-align: left;
`;

let lista_titular_comite_representantes;
let comite, state, borrar_representante = 0;
let nuevo_representante_id, url;

const { Option } = Select;
const AutoCompleteOption = AutoComplete.Option;

const success = (messages) => {
  message.success(messages);
};

const error = (messages) => {
  message.error(messages);
};

const warning = (messages) => {
  message.warning(messages);
};

const borrarRepresentante = (e) => {
  borrar_representante = e.currentTarget.getAttribute('data-id-representante');



  this.setState({
    visibleBorrar: true
  });

}

const cambiarAdmin = (e) => {
  nuevo_representante_id = e.currentTarget.getAttribute('data-id-representante');


  this.setState({
    visibleAdmin: true
  });

}





function onChange(pagination, filters, sorter, extra) {

}



class ListaRepresentantes extends Component {

  constructor(props) {
    super(props);

    //state = this;

    this.state = {
      visibleBorrar: false,
      visibleAdmin: false,
      representantes: [{
        is_titular: false
      }],
      loading: false,
      nombre_comite: '',
      whoami: {},
      visibleEditar: false,
      form_id: '',
      form_nombre: '',
      form_cargo: '',
      form_telefono: '',
      form_profesion: '',

    }

    this.otra_profesion = React.createRef();


    this.actualizarRepresentantes();



  }

  columns_usuario = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      render: text => <span>{text}</span>,
    },
    {
      title: 'E-mail',
      dataIndex: 'email',
      key: 'email',
      render: text => <span><a href={`mailto:${text}`}>{text}</a></span>,
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono',
      key: 'telefono',
      render: text => <span><a href={`tel:${text}`}>{text}</a></span>,
    },
    {
      title: 'Cargo en la Empresa',
      dataIndex: 'cargo',
      key: 'cargo',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Profesión',
      dataIndex: 'profesion',
      key: 'profesion',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Representante',
      dataIndex: 'is_titular',
      key: 'is_titular',
      render: (text, record) => (
        <span>
          {text ?
            (
              <span><FontAwesomeIcon className="icon_user_admin" icon={faUserTie} /> Titular </span>
            )
            :
            (<span><FontAwesomeIcon className="icon_user_no_admin" icon={faUserTie} /> Suplente </span>)
  
          }
        </span>
      ),
    },
    {
      title: 'Editar',
      dataIndex: 'representante_id',
      key: 'representante_id',
      render: (text, record) => (
        <span>
  
          {this.state.whoami.id == text &&
  
            <FontAwesomeIcon data-id-representante={text} className="icon_user_edit" icon={faUserEdit} onClick={()=> this.showDrawer()} />
  
          }
  
  
  
        </span>
      ),
    },
  ];

  columns_admin = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      render: text => <span>{text}</span>,
    },
    {
      title: 'E-mail',
      dataIndex: 'email',
      key: 'email',
      render: text => <span><a href={`mailto:${text}`}>{text}</a></span>,
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono',
      key: 'telefono',
      render: text => <span><a href={`tel:${text}`}>{text}</a></span>,
    },
    {
      title: 'Cargo en la Empresa',
      dataIndex: 'cargo',
      key: 'cargo',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Profesión',
      dataIndex: 'profesion',
      key: 'profesion',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Representante',
      dataIndex: 'is_titular',
      key: 'is_titular',
      render: (text, record) => (
        <span>
          {text ?
            (
              <span><FontAwesomeIcon className="icon_user_admin" icon={faUserTie} /> Titular</span>
            )
            :
            (<span><FontAwesomeIcon onClick={cambiarAdmin} data-id-representante={record.representante_id} className="icon_user_no_admin" icon={faUserTie} /> Suplente </span>)
  
          }
        </span>
      ),
    },
    {
      title: 'Editar',
      dataIndex: 'representante_id',
      key: 'representante_id',
      render: (text, record) => (
        <span>
  
          <FontAwesomeIcon data-id-representante={text} className="icon_user_edit" icon={faUserEdit} onClick={() => this.showDrawer()} />
  
          <Divider type="vertical" />
          {!record.is_titular &&
            (<FontAwesomeIcon onClick={borrarRepresentante} data-id-representante={text} className="icon_user_delete" icon={faUserTimes} />)
          }
  
        </span>
      ),
    },
  ];
  

  showDrawer = (e) => {

    console.log(e.target.parentElement.getAttribute('data-id-representante'));
    let id_form = e.target.parentElement.getAttribute('data-id-representante');
    this.setState({
      loading: true
    });
    titular_comite_representante(0, e.target.parentElement.getAttribute('data-id-representante')).then(data => {
      console.log(data);

      this.setState({
        loading: false
      });
      switch (data.status) {
        case 0:


          this.setState({
            form_id: id_form,
            form_nombre: data.data.nombre,
            form_cargo: data.data.cargo,
            form_telefono: data.data.telefono,
            form_profesion: data.data.profesion,
            visibleEditar: true,
          });

          break;
        case 5:
          error('Error de Conexión');
          break;
      }

    });


  };

  onClose = () => {

    this.setState({
      form_id: '',
      form_nombre: '',
      form_cargo: '',
      form_telefono: '',
      form_profesion: '',
      visibleEditar: false,
    });

  };

  componentWillMount() {
    switch (this.props.match.params.num_comite) {
      case '1': this.setState({ nombre_comite: 'Comité de Seguridad Vial' }); break;
      case '2': this.setState({ nombre_comite: 'Comité de Prevención y Combate al Delito' }); break;
      case '3': this.setState({ nombre_comite: 'Comité de Movilidad' }); break;
      case '4': this.setState({ nombre_comite: 'Comité Ferroviario' }); break;
      case '5': this.setState({ nombre_comite: 'Comité Jurídico' }); break;
      case '6': this.setState({ nombre_comite: 'Comité Técnico' }); break;
      default: break;
    }


  }

  async actualizarRepresentantes() {

    this.setState({
      loading: true
    });

    titular_comite_representantes(this.props.match.params.num_comite).then(async({status = 5, data: representantes}) => {


      this.setState({
        loading: false
      });

      switch (status) {
        case 0:
         const {data: whoami} = await whoAmI(this.props.match.params.num_comite)

         this.setState({
          whoami,
          representantes
        });
          break;
        case 5:
          error('Error de Conexión');
          break;
          default:
          break;
      }

    });



  }

  componentDidMount() {
    const { match: { params } } = this.props;

    comite = params.comite;

    this.setState({
      comite: params.comite
    });



  }

  handleOkBorrar = e => {

    this.setState({
      loading: true
    });

    eliminar_representante(this.props.match.params.num_comite, borrar_representante).then(data => {

      this.setState({
        loading: false
      });

      switch (data.status) {
        case 5:
          error('Error de Conexión');
          break;
        case 10:
          success('Usuario Eliminado');
          break;
      }

      this.actualizarRepresentantes();

    });

    this.setState({
      visibleBorrar: false,
    });


  };

  handleOkAdmin = e => {


    let dataJson = {
      "representante_id": nuevo_representante_id,
      "comite_id": this.props.match.params.num_comite
    }

    this.setState({
      loading: true
    });
    actualizarTitular(dataJson).then(data => {

      this.setState({
        loading: false
      });

      switch (data.status) {
        case 0:
          success('Titular cambiado');
          state.actualizarRepresentantes();
          break;
        case 5:
          error('Error de Conexión');
          switch (this.props.match.params.num_comite) {
            case 1: url = 'comite-nacional-seguridad-vial'; break;
            case 2: url = 'comite-prevencion-y-combate-al-delito'; break;
            case 3: url = 'comite-movilidad'; break;
            case 4: url = 'comite-ferroviario'; break;
            case 5: url = 'comite-juridico'; break;
            case 6: url = 'comite-tecnico'; break;
          }

          window.location.href = '/login/' + url + '/' + this.props.match.params.num_comite;
          break;

      }

    });



    this.setState({
      visibleAdmin: false,
    });
  };

  handleCancel = e => {

    this.setState({
      visibleBorrar: false,
      visibleAdmin: false
    });
  };


  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {

        this.setState({
          loading: true
        });


        values['id'] = this.state.form_id;
        console.log('Received values of form: ', values);

        actualizar_campos_representante(values).then(data => {

          this.setState({
            loading: false
          });

          switch (data.status) {
            case 0:
              success('Cambios guardados');
              state.onClose();
              state.actualizarRepresentantes();
              break;
            case 5:
              error('Error de Conexión');
              break;
          }
        });

      }
    });
  };

  handleChange(value) {
    console.log(`selected ${value}`);
    if (value === 'otro') {
      this.setState({ mostrar_otro_cargo: true });
    } else {
      this.setState({ mostrar_otro_cargo: false });
    }
  }

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };



  render() {

    const { getFieldDecorator } = this.props.form;
    const { autoCompleteResult } = this.state;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };


    return (
      <Spin spinning={this.state.loading}>
        <Row>
          <Modal
            title="Eliminar Registro"
            visible={this.state.visibleBorrar}
            onOk={this.handleOkBorrar}
            onCancel={() => this.handleCancel()}
          >
            <p>¿Esta seguro de eliminar este representante?</p>
          </Modal>

          <Modal
            title="Cambiar de Titular"
            visible={this.state.visibleAdmin}
            onOk={this.handleOkAdmin}
            onCancel={() => this.handleCancel()}
          >
            <p>¿Desea asignar el roll de titular a esta persona?</p>
          </Modal>

          <NavBar admin_empresa={this.state.whoami.is_titular} comite={this.props.match.params.num_comite} />

          <Col span={16}>
            <h3Test>Bienvenido al {this.state.nombre_comite}</h3Test>
            <Table
              columns={this.state.whoami.is_titular ? this.columns_admin : this.columns_usuario}
              dataSource={this.state.representantes} onChange={onChange} />
          </Col>

          <Drawer
            title="Actualizar Registro"
            width={720}
            onClose={this.onClose}
            visible={this.state.visibleEditar}
            bodyStyle={{ paddingBottom: 80 }}
          >
            <Form {...formItemLayout} onSubmit={this.handleSubmit}>

              {this.state.form_nombre != '' &&
                <Form.Item
                  label={
                    <span>
                      Nombre:
            </span>
                  }
                >
                  {getFieldDecorator('nombre', {
                    rules: [{ required: true, message: 'Por favor escribe un nombre', whitespace: true }],
                    initialValue: this.state.form_nombre,
                  })(<Input />)}
                </Form.Item>}

              {this.state.form_cargo != '' &&
                <Form.Item
                  label={
                    <span>
                      Cargo:
            </span>
                  }
                >
                  {getFieldDecorator('cargo', {
                    rules: [{ required: true, message: 'Por favor escribe un cargo', whitespace: true }],
                    initialValue: this.state.form_cargo,
                  })(<Input  />)}
                </Form.Item>}

              {this.state.form_telefono != '' &&
                <Form.Item
                  label={
                    <span>
                      Teléfono:
            </span>
                  }
                >
                  {getFieldDecorator('telefono', {
                    rules: [{ required: true, message: 'Por favor escribe un teléfono', whitespace: true }],
                    initialValue: this.state.form_telefono,
                  })(<Input />)}
                </Form.Item>}

              {this.state.form_profesion != '' &&
                <Form.Item
                  label={
                    <span>
                      Profesión:
            </span>
                  }
                >
                  {getFieldDecorator('profesion', {
                    rules: [{ required: true, message: 'Por favor elige una profesión', whitespace: true }],
                    initialValue: this.state.form_profesion,
                  })(
                    <Select ref={this.form_cargo} onChange={this.handleChange}>
                      <Option value="Ing.">Ing.</Option>
                      <Option value="Lic.">Lic.</Option>
                      <Option value="Maestro">Maestro</Option>
                      <Option value="Contador Público">Contador Público</Option>
                      <Option value="otro">Otro</Option>
                    </Select>
                  )}
                </Form.Item>}

              {this.state.mostrar_otro_cargo &&

                <Form.Item
                  label={
                    <span>
                      Otro:
            </span>
                  }
                >
                  {getFieldDecorator('otra_profesion', {
                    rules: [{ required: true, message: 'Por favor escribe un teléfono', whitespace: true }],
                    initialValue: this.state.form_profesion,
                  })(<Input />)}
                </Form.Item>}





              <Form.Item {...tailFormItemLayout}>
                <Button type="primary" htmlType="submit">
                  Actualizar
          </Button>
              </Form.Item>
            </Form>
          </Drawer>

        </Row>

      </Spin>
    );
  }
}

const WrappedRegistrationForm = Form.create({ name: 'register' })(ListaRepresentantes);

export default WrappedRegistrationForm;
